export default __webpack_public_path__ + "static/media/logo.5d4e4295.png";